import { Record } from "immutable";

import { ApprovalFlowNotifiedEntityModel } from "./ApprovalFlowNotifiedEntityModel";

const NO_IDENTIFIER_APPROVAL_FLOW_ENTITY_TYPE = [
  "Automatic" as const,
  "DirectManager" as const,
  "IntegrationMaintainer" as const,
  "IntegrationOwner" as const,
  "ResourceMaintainer" as const,
  "ResourceOwner" as const,
  "TeamMember" as const,
];

export type TApprovalFlowEntityType =
  | "DirectoryGroup"
  | "HR"
  | "OnCallIntegrationSchedule"
  | "SlackChannel"
  | "User"
  | "Webhook"
  | TNoIdentifierApprovalFlowEntityType;

type TNoIdentifierApprovalFlowEntityType = (typeof NO_IDENTIFIER_APPROVAL_FLOW_ENTITY_TYPE)[number];

export const isNoIdentifierApprovalFlowEntityType = (
  entityType: TApprovalFlowEntityType,
): entityType is TNoIdentifierApprovalFlowEntityType =>
  NO_IDENTIFIER_APPROVAL_FLOW_ENTITY_TYPE.includes(entityType as TNoIdentifierApprovalFlowEntityType);

const defaults = {
  displayName: null as null | string,
  identifier: null as null | string,
  type: "" as TApprovalFlowEntityType,
};

export interface IApprovalFlowEntitySchema {
  displayName: null | string;
  identifier: null | string;
  type: TApprovalFlowEntityType;
}

export class ApprovalFlowEntityModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { displayName, identifier, type } = data as IApprovalFlowEntitySchema;

    return new ApprovalFlowEntityModel({
      displayName,
      identifier: isNoIdentifierApprovalFlowEntityType(type) ? type : identifier,
      type,
    });
  }

  toNotifiedEntity(): ApprovalFlowNotifiedEntityModel {
    const { displayName, identifier, type } = this;
    if (type === "Automatic") throw new Error("Cannot convert automatic type entity to notified entity");
    return new ApprovalFlowNotifiedEntityModel({
      displayName,
      identifier,
      type,
    });
  }

  toServerData(): IApprovalFlowEntitySchema {
    const { displayName, identifier, type } = this;
    return {
      displayName,
      identifier: isNoIdentifierApprovalFlowEntityType(type) ? null : identifier,
      type,
    };
  }
}
